import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUXPContext } from '@core/context/useUXPContext';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import Button from '@widget/buttons/Button';
import Input from '../Input';
/**
 * @export
 * Paste-a-URL view with a live preview of whatever was typed.
 */
const UrlView = (props) => {
    const { urlEntry, onUrlChange, onApply, multiple } = props;
    const context = useUXPContext();
    return _jsx("div", { className: "uxpcore_mediapicker__urlview", children: _jsxs("div", { className: "uxpcore_mediapicker__urlview-input", children: [_jsx(Input, { value: urlEntry, onChange: (v) => onUrlChange(v), placeholder: context.$L('uxp-core.text.paste-image-url'), prefix: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'link'] }), onKeyDown: (e) => { if (e.key === 'Enter')
                        onApply(); }, fullWidth: true }), multiple &&
                    _jsx(Button, { className: "uxpcore_mediapicker__urlview-apply", title: context.$L('uxp-core.text.add'), variant: "primary", size: "small", disabled: !urlEntry.trim(), onClick: onApply })] }) });
};
export default UrlView;
